import styles from './ProximoPasso.module.scss'
import { openWhatsApp } from '../constants'
import fotoFrancis from '../../assets/images/optimized/proximo-passo-francis.webp'

const FEATURES = [
  { icon: 'chat', label: 'Atendimento online' },
  { icon: 'workspace_premium', label: 'Especialista ao seu lado' },
  { icon: 'language', label: 'Para falantes do português, no Brasil e no exterior' },
]

const ProximoPasso = () => (
  <section className={styles.section}>
    <div className={styles.inner}>
      <div className={styles.left}>
        <p className={styles.kicker}>Próximo passo</p>
        <h2>
          Sua comunicação pode <span>evoluir.</span>
        </h2>
        <p className={styles.lead}>Vamos juntos nessa jornada!</p>

        <div className={styles.features}>
          {FEATURES.map(feature => (
            <div key={feature.label} className={styles.feature}>
              <i className="material-icons">{feature.icon}</i>
              <span>{feature.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.media}>
        <img
          src={fotoFrancis}
          alt="Fga. Francis Guimarães"
          width={840}
          height={1260}
          loading="lazy"
          decoding="async"
        />
        <div className={styles.card}>
          <p>
            Agende sua avaliação e dê o primeiro passo para uma comunicação mais
            leve e eficaz.
          </p>
          <button type="button" className={styles.cta} onClick={openWhatsApp}>
            Agendar avaliação <i className="material-icons">chat</i>
          </button>
        </div>
      </div>
    </div>
  </section>
)

export default ProximoPasso
